var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-icon',_vm._g(_vm._b({attrs:{"icon_name":"search"}},'input-icon',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }